import { POST } from '../_http';
import type { operations } from '@/types/schemas/calcs.main';
type controller = operations['SettlementFeeController_calculate'];

export type SettlementFeeBody = controller['requestBody']['content']['application/json'];
export type SettlementFeeResponse = controller['responses']['200']['content']['application/json'];

export const settlementFee = POST('/formulas/settlement-fee')<SettlementFeeBody, SettlementFeeResponse>;
